import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIEText from '@src/shared/components/PIEText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../QRCodeDownloadContent.module.scss';
import QRCode from 'react-qr-code';
import { IconHelmet } from '@justeattakeaway/pie-icons-react';
interface componentProps {
  logo: string;
  qrCode: string;
}
const QRCodeDownloadPrintContent = ({ logo, qrCode }: componentProps) => {
  const { t } = useTranslation();
  return (
    <>
      <img src={logo} width={100} height={100} style={{ marginTop: '50px', marginLeft: '340px' }} />

      <div style={{ width: '400px', marginTop: '50px', marginLeft: '200px' }}>
        <PIEText
          size={'var(--xds-font-size-32)'}
          fontWeight="var(--xds-font-weight-bold)"
          text={t('ocf_screens.QR_CODE_DOWNLOAD_POSTER_TITLE')}
          align="center"
        />
      </div>
      <div style={{ marginTop: '50px', marginLeft: '230px' }}>
        <PIEComponentUtil marginBottom="var(--xds-spacing-b)">
          <PIEText
            size={'var(--xds-font-size-16)'}
            fontWeight="var(--xds-font-weight-regular)"
            text={
              <div style={{ width: '300px' }}>
                <span
                  className={styles.chip}
                  style={{
                    width: '28px',
                    height: '31px',
                    paddingTop: '3px',
                    paddingLeft: '8px',
                  }}
                >
                  1
                </span>
                {t('ocf_screens.QR_CODE_DOWNLOAD_STEP_1_CONTENT')}
              </div>
            }
            align="center"
          />
        </PIEComponentUtil>
      </div>
      <div style={{ marginTop: '30px', marginLeft: '228px' }}>
        <PIEComponentUtil marginBottom="var(--xds-spacing-b)">
          <PIEText
            size={'var(--xds-font-size-16)'}
            fontWeight="var(--xds-font-weight-regular)"
            text={
              <div style={{ width: '300px' }}>
                <span
                  className={styles.chip}
                  style={{
                    width: '30px',
                    height: '31px',
                    paddingTop: '3px',
                    paddingLeft: '6px',
                  }}
                >
                  2
                </span>
                {t('ocf_screens.QR_CODE_DOWNLOAD_STEP_2_CONTENT')}
              </div>
            }
            align="center"
          />
        </PIEComponentUtil>
      </div>
      <div
        style={{
          width: '300px',
          display: 'flex',
          justifyContent: 'center',
          marginLeft: '240px',
          marginTop: '50px',
        }}
      >
        <div className={styles.qrCodeContainer}>
          <QRCode value={qrCode} size={350}></QRCode>
        </div>
      </div>
      <div
        style={{
          width: '220px',
          height: '40px',
          marginLeft: '290px',
          marginTop: '50px',
        }}
      >
        <PIEComponentUtil marginTop="var(--xds-spacing-b)">
          <div className={styles.bottomTag} style={{ fontSize: '16px', paddingBottom: '1px' }}>
            <IconHelmet size="m" className={styles.tagIcon} style={{ marginRight: '10px' }} />
            {t('ocf_screens.QR_CODE_DOWNLOAD_FOOTER_TAG')}
          </div>
        </PIEComponentUtil>
      </div>
    </>
  );
};

export default QRCodeDownloadPrintContent;
